export enum WIDGET_CONTENT_LIST {
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=825456451
     */
    CONTENT_LIST_CRITERIA_AUTHOR_HELPER = 'DESIGNER.CONTENT_LIST_CRITERIA_AUTHOR_HELPER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=825456437
     */
    CONTENT_LIST_CRITERIA_CONTENT_TYPES_HELPER = 'DESIGNER.CONTENT_LIST_CRITERIA_CONTENT_TYPES_HELPER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=825456473
     */
    CONTENT_LIST_CRITERIA_FEATURED_HELPER = 'DESIGNER.CONTENT_LIST_CRITERIA_FEATURED_HELPER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=825456523
     */
    CONTENT_LIST_CRITERIA_HIGHLIGHTED_HELPER = 'DESIGNER.CONTENT_LIST_CRITERIA_HIGHLIGHTED_HELPER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=825456217
     */
    CONTENT_LIST_SOURCE_DEFAULT_DESCRIPTION = 'DESIGNER.CONTENT_LIST_SOURCE_DEFAULT_DESCRIPTION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=825456296
     */
    CONTENT_LIST_SOURCE_ONLY_FAVORITES_LABEL = 'DESIGNER.CONTENT_LIST_SOURCE_ONLY_FAVORITES_LABEL',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=825456261
     */
    CONTENT_LIST_SOURCE_SELECTED_INSTANCES_LABEL = 'DESIGNER.CONTENT_LIST_SOURCE_SELECTED_INSTANCES_LABEL',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=825456277
     */
    CONTENT_LIST_SOURCE_SIBLING_INSTANCES_LABEL = 'DESIGNER.CONTENT_LIST_SOURCE_SIBLING_INSTANCES_LABEL',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=748964846
     */
    CONTENT_LIST_WIDGET_SETTINGS_TITLE = 'DESIGNER.CONTENT_LIST_WIDGET_SETTINGS_TITLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=826172600
     */
    SORT_PUBLICATION_DATE_LABEL = 'WIDGET_CONTENT_LIST.SORT_PUBLICATION_DATE_LABEL',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=830782832
     */
    EMPTY_STATE_DESCRIPTION = 'DESIGNER.WIDGET_CONTENT_LIST_EMPTY_STATE_DESCRIPTION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=524500748
     */
    WRITER_MODE_EMPTY_STATE_TITLE = 'CONTENT_ADMIN.NO_CONTENT_TITLE',
}
